import { WSFlexBox, WSIcon, WSText } from "@wingspanhq/fe-component-library";

type Props = {
  name: string;
};

/**
 * Names the client behind a requirement. Presentational: the name is resolved by
 * `useRequirementsConfig().getRequirementPayerName`, off the payer *search rows*
 * keyed by `payerAccountId`.
 *
 * It deliberately does not read a `Payer` by id — a v3 `Payer.id` is not the
 * payer's account id (it is the composite `<payerAccountId>_<payeeAccountId>` for
 * a linked client, and a standalone id for a platform payer), so the
 * `getPayer({ payerId: payerAccountId })` this used to do 404'd and the label
 * rendered nothing at all.
 */
export const LabelPayerName: React.FC<Props> = ({ name }) => {
  if (!name) {
    return null;
  }

  return (
    <WSFlexBox alignItems="center" gap="XS" wrap="nowrap">
      <WSIcon color="gray600" name="user" size="S" />
      <WSText.ParagraphXs color="gray600">{name}</WSText.ParagraphXs>
    </WSFlexBox>
  );
};
